"use client";

import { useEffect } from "react";

/**
 * 滑動續期 client 端定時器
 *   - 每 10 分鐘靜默 POST /api/auth/refresh
 *   - server 自己決定是否重簽（剩 >2h 不換 · 剩 ≤2h 才換 cookie）
 *   - 收到 401 → 已失效（超過 12h+2h 的 window 都沒刷到）· 不自動跳 login 避免卡 modal · 讓下一個業務請求去跳
 *   - mount 在 root layout · 全站生效
 *
 * 搭配 B 版 fetch wrapper 使用：業務請求遇 401 才 redirect，此處只負責續期
 */
const REFRESH_INTERVAL_MS = 10 * 60 * 1000; // 10 分鐘

export default function AuthRefresher({ enabled }: { enabled: boolean }) {
  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;
    async function tick() {
      if (cancelled) return;
      try {
        await fetch("/api/auth/refresh", {
          method: "POST",
          credentials: "include",
          // 不等 response · 不阻塞 · 失敗不吵
        });
      } catch {
        /* 網路錯誤忽略 · 下一輪再試 */
      }
    }

    // 進頁面 30 秒後先跑一次（避免剛登入的首刷打到 server）
    const first = setTimeout(tick, 30_000);
    const interval = setInterval(tick, REFRESH_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearTimeout(first);
      clearInterval(interval);
    };
  }, [enabled]);

  return null;
}
